const getters = {
  device: state => state.datacenter.publicGlobalPropertise.device,
  pwUpdateFlag: state => state.datacenter.publicGlobalPropertise.pwUpdateFlag,
  asideCollapse: state => state.d2admin.menu.asideCollapse,
  hasAside: state => state.d2admin.menu.hasAside,
  userPermissionModules: state => state.d2admin.user.info.moduleList
}
export default getters
